export default "__VITE_ASSET__B4y2vpke__"